// extracted by mini-css-extract-plugin
module.exports = {"stack":"page_stack__Ho8P_","root":"page_root__v6pxB","text":"page_text__0kU3c"};